import React from 'react'
import PropTypes from "prop-types"
import { ControlLabel, Modal, Panel, Glyphicon } from 'react-bootstrap'
import ReactMarkdown from 'react-markdown'
import { isString } from "lodash"

import { getText } from '../lib/text.js'
import SimpleMDE from '../lib/SimpleMDE'
import Button from '../components/Button'
import './MarkdownField.less'

/**
 *
 */

const MDModal = ({ onSave, onChange, initialValue, label, smallLabel, botLabel }) => (
  <Modal onHide={onSave} show bsSize="large">
    <Modal.Header>
      <Modal.Title>
        {label} <small>{smallLabel}</small>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <SimpleMDE
        options={{ initialValue, spellChecker: false, autofocus: true }}
        onChange={x => onChange(x)}
      />
      <div>{botLabel}</div>
    </Modal.Body>
    <Modal.Footer>
      <Button glyph="save" onClick={onSave}>{getText("Ok")}</Button>
    </Modal.Footer>
  </Modal>
)

MDModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired, // string => void,
  initialValue: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  smallLabel: PropTypes.string,
  botLabel: PropTypes.string,
}

/**
 *
 */

class MarkdownField extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modal: !!props.forceOpen, // start already open?
      initialValue: props.value,
      lastValue: props.value
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.forceOpen && !this.state.modal && nextProps.forceOpen) {
      // told to open from parent component
      this.open()
    }
  }

  isOpen() { return this.state.modal }

  saveAndClose() {
    this.props.onChange(this.state.lastValue)
    this.setState({ modal: false, initialValue: null })
  }

  close() {
    this.setState({ modal: false, initialValue: null })
  }

  open() {
    this.setState({ modal: true, initialValue: this.props.value })
  }

  change(v) {
    this.setState({ lastValue: v })
  }

  render() {
    const { className, label, smallLabel, botLabel, placeholder, disabled, sublabel, style } = this.props
    
    // 
    const value = isString(this.props.value) ? this.props.value : JSON.stringify(this.props.value)

    return (
      <React.Fragment>
        {
          this.isOpen() && (
            <MDModal
              onCancel={() => this.close()}
              onSave={() => this.saveAndClose()}
              onChange={v => this.change(v)}
              initialValue={this.state.initialValue}
              smallLabel={smallLabel}
              botLabel={botLabel}
              label={label}
            />
          )
        }

        <div className={className + " mardownfield"} style={{ marginBottom: 20, ...(style || {}) }}>
          <ControlLabel>
            {label} <small>{smallLabel}</small>
          </ControlLabel>
          {
            sublabel && (
              <div style={{ color: "#555", marginBottom: 2, fontSize: 14, fontStyle: "italic" }}>
                {sublabel}
              </div>
            )
          }
          <Panel
            style={{
              ...(disabled ? { backgroundColor: "#ddd" } : {}),
              marginBottom: 0
            }}
            onClick={() => { if (!disabled) this.open() }}
          >
            <Panel.Body>
              <ReactMarkdown
                source={disabled ? "" : (value || placeholder)}
                renderers={{
                  link: "code"
                  // link: (a, b, c) => <code>{JSON.stringify({ a, b, c })}</code>
                }}
              />
              <div className="actionButton">
                <Glyphicon id="lapiz" glyph="pencil" className="editPencil" />
                {
                  //console.log(this.props.onRemoveClick )
                  this.props.onRemoveClick && (
                    <Glyphicon glyph="remove" className="removeArrow" onClick={event => {
                      this.props.onRemoveClick()
                      event.stopPropagation()
                    }} />
                  )
                }
                {
                  
                }
              </div>
            </Panel.Body>
          </Panel>
        </div>
      </React.Fragment>
    )
  }
}

MarkdownField.propTypes = {
  onChange: PropTypes.func.isRequired, // string => void,
  value: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  sublabel: PropTypes.node,
  smallLabel: PropTypes.node,
  botLabel: PropTypes.node,
  placeholder: PropTypes.string,

  onRemoveClick: PropTypes.func,

  disabled: PropTypes.bool,
  forceOpen: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
}

MarkdownField.defaultProps = {
  forceOpen: false,
  disabled: false,
  smallLabel: "",
  placeholder: "",
  style: {},
  className: ""
}

export default MarkdownField
